import { Box } from '@alf/uikit';
import { FILTER_TYPES } from '../../../../constants';
import { GamesSearchCategoriesFilter } from './CategoriesFilter';
import { GamesSearchProvidersFilter } from './ProvidersFilter';

export const GamesFiltersSection = ({
  feedName,
  isFeedLoaded,
  filterData,
  withCategoriesFilter,
  withProvidersFilter
}) => {
  const { filterState, applyFilter, resetFilter } = filterData;
  return (
    <Box direction="column">
      {withProvidersFilter && (
        <GamesSearchProvidersFilter
          feedName={feedName}
          onApplyClick={(selectedProviders) =>
            applyFilter(FILTER_TYPES.PROVIDERS, selectedProviders)
          }
          onResetClick={() => resetFilter(FILTER_TYPES.PROVIDERS)}
          selectedProviders={filterState.providers}
          isLoading={!isFeedLoaded}
        />
      )}
      {withCategoriesFilter && (
        <GamesSearchCategoriesFilter
          feedName={feedName}
          onApplyClick={(selectedCategories) =>
            applyFilter(FILTER_TYPES.CATEGORIES, selectedCategories)
          }
          onResetClick={() => resetFilter(FILTER_TYPES.CATEGORIES)}
          selectedCategories={filterState.categories}
          isLoading={!isFeedLoaded}
        />
      )}
    </Box>
  );
};
